import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text, TextTypography as TYPOGRAPHY } from 'wix-ui-tpa/cssVars';
import settingsParams from '../../settingsParams';
import { DataHooks } from '../Body/consts';
import { classes, st } from './NewGrid.st.css';

interface NewGridProps {
  title?: string;
  dataHook: string;
  numberOfServices: number;
  id?: string;
}

export const NewGrid: FC<NewGridProps> = ({
  title,
  dataHook,
  children,
  numberOfServices,
  id,
}) => {
  const { isMobile } = useEnvironment();
  const settings = useSettings();
  const { experiments } = useExperiments();
  const isStripLayoutMultiColumnEnabled = experiments.enabled(
    'specs.bookings.stripLayoutMultiColumn',
  );

  return (
    <div
      className={st(classes.gridWrapper, {
        isMobile,
        numberOfServices,
        isStripLayoutMultiColumnEnabled,
      })}
      data-hook={dataHook}
      id={id}
    >
      {title && (
        <Text
          className={classes.menuTitle}
          data-hook={DataHooks.MENU_TITLE}
          typography={TYPOGRAPHY.smallTitle}
          tagName={settings.get(settingsParams.widgetMenuTitleFontHtmlTag)}
        >
          {title}
        </Text>
      )}
      <ul
        data-hook="Grid-container"
        className={st(classes.gridContainer, {
          uniformRowHeight: !isMobile,
        })}
      >
        {children}
      </ul>
    </div>
  );
};
